import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../shared/button/Button';
import { ROUTES } from '../../reactRoute/RouteConstants';
import { useUser } from '../../UserContext';
import { ConsumerIcon, HeadPhoneIcon } from '../../Icons';

function Navbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const { userType, setUserType } = useUser();
    const [menuOpen, setMenuOpen] = useState(false);
    const [userDropOpen, setUserDropOpen] = useState(false);
    const menuRef = useRef(null);
    const userRef = useRef(null);

    const isHomePage = location.pathname === ROUTES.home;
    const isContactPage = location.pathname === ROUTES.djContact;
    const isConsumerContactPage = location.pathname === ROUTES.customerContact;
    const isConsumerHomePage = location.pathname === ROUTES.customerHome;

    const handleUserTypeChange = (type) => {
        setUserType(type);
        if (type === 'consumer') {
            navigate(ROUTES.customerHome);
        } else {
            navigate(ROUTES.home); // Replace with appropriate DJ home route
        }
    };

    const renderLinks = () => {
        if (userType === 'consumer') {
            return (
                <>
                    <Link
                        to={ROUTES.customerHome}
                        className={`font-[500] text-[#111111] ${isConsumerHomePage ? 'max-sm:after:!opacity-0 max-sm:text-[#F02E49] relative after:absolute after:top-[110%] after:left-0 after:h-[3px] after:w-full after:bg-[#F02E49]' : ''}`}
                    >
                        Home
                    </Link>
                    <Link
                        to={ROUTES.customerContact}
                        className={`font-[500] text-[#111111] ${isConsumerContactPage ? 'max-sm:after:!opacity-0 max-sm:text-[#F02E49] relative after:absolute after:top-[110%] after:left-0 after:h-[3px] after:w-full after:bg-[#F02E49]' : ''}`}
                    >
                        Contact
                    </Link>
                </>
            );
        } else if (userType === 'dj') {
            return (
                <>
                    <Link
                        to={ROUTES.home} // Change this to the appropriate DJ home route
                        className={`font-[500] text-[${isHomePage ? '#F02E49' : '#111111'}] ${isHomePage ? 'max-sm:after:!opacity-0 max-sm:text-[#F02E49] relative after:absolute after:top-[110%] after:left-0 after:h-[3px] after:w-full after:bg-[#F02E49]' : ''}`}
                    >
                        Home
                    </Link>
                    <Link
                        to={ROUTES.djContact}
                        className={`font-[500] text-[${isContactPage ? '#F02E49' : '#111111'}] ${isContactPage ? 'max-sm:after:!opacity-0 max-sm:text-[#F02E49] relative after:absolute after:top-[110%] after:left-0 after:h-[3px] after:w-full after:bg-[#F02E49]' : ''}`}
                    >
                        Contact
                    </Link>
                </>
            );
        }
        return null;
    };

    const handleUserDropToggle = () => {
        setUserDropOpen(!userDropOpen);
    };

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setMenuOpen(false);
        }
    };

    const userHandleClickOutside = (event) => {
        if (userRef.current && !userRef.current.contains(event.target)) {
            setUserDropOpen(false); // Corrected to close user dropdown
        }
    };

    useEffect(() => {
        setMenuOpen(false); // Close the menu on route change
    }, [location.pathname]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', userHandleClickOutside);
        return () => {
            document.removeEventListener('mousedown', userHandleClickOutside);
        };
    }, []);

    return (
        <div className="flex items-center justify-between  py-[6px] max-sm:px-[24px]  max-2xl:px-[7.7vw] max-w-[1600px] w-full">
            <img src="/logo.png" className="sm:w-[140px] w-[100px]" alt="" />
            <div className="flex items-center gap-[32px] max-sm:hidden">
                {renderLinks()}
            </div>
            <div className="flex items-center gap-[14px] sm:gap-[24px]">
                <div className="relative" ref={userRef}>
                    <ConsumerIcon className='cursor-pointer' onClick={handleUserDropToggle}/>
                    {userDropOpen && (
                        <div className="absolute top-[110%] max-sm:left-0 sm:right-0 p-[12px] w-[200px] flex flex-col gap-[12px] rounded-[12px] bg-[#FFF] z-50 shadow-xl shadow-[#00000020]">
                            <div className={`group flex items-center cursor-pointer gap-[16px] ${userType === 'consumer' ? 'text-[#F02E49]' : 'text-[#666]'}`} onClick={() => handleUserTypeChange('consumer')}>
                                <ConsumerIcon className={'cursor-pointer'} iconColor={userType === 'consumer' ? 'text-[#F02E49]' : 'text-[#666]'}  />
                                <span className={'group-hover:translate-x-1 transition-all'}>
                                    Consumer
                                </span>
                            </div>
                            <div className={`group flex items-center cursor-pointer gap-[16px] ${userType === 'dj' ? 'text-[#F02E49]' : 'text-[#666]'}`} onClick={() => handleUserTypeChange('dj')}>
                                <HeadPhoneIcon className={'cursor-pointer'} iconColor={userType === 'dj' ? 'text-[#F02E49]' : 'text-[#666]'}  />
                                <span className={'group-hover:translate-x-1 transition-all'}>
                                    DJs
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="relative" ref={menuRef}>
                    <i className="ri-menu-4-line sm:hidden text-[#475467] text-[24px]" onClick={handleMenuToggle}></i>
                    {menuOpen && (
                        <div className="absolute top-[110%] right-0 p-[12px] w-[200px] flex flex-col gap-[12px] rounded-[12px] bg-[#FFF] z-50 shadow-2xl shadow-[#00000020">
                            {renderLinks()}
                        </div>
                    )}
                </div>
                <Button children="Get in Touch" />
            </div>
        </div>
    );
}

export default Navbar;
